import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Login = () => import('../views/Login.vue')
const Layout = () => import('../views/Layout.vue')
const Dashboard = () => import('../views/Dashboard.vue')
const Products = () => import('../views/Products.vue')
const Orders = () => import('../views/Orders.vue')
const Users = () => import('../views/Users.vue')

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name: 'Login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      meta: { auth: true },
      children: [
        { path: 'dashboard', component: Dashboard, meta: { auth: true } },
        { path: 'products', component: Products, meta: { auth: true } },
        { path: 'orders', component: Orders, meta: { auth: true } },
        { path: 'users', component: Users, meta: { auth: true } }
      ]
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !localStorage.getItem('admin_token')) {
    next('/login')
    return
  }

  if (to.path === '/login' && localStorage.getItem('admin_token')) {
    next('/dashboard')
    return
  }

  next()
})

export default router
